<template>
  <div class="w-full">
    <Head title="123" />
    <el-container class="h-full">
      <el-aside class="bg-gray-100" width="250px" style="height: 100%;">
        <app-menu :auth="auth" :forms="forms" :active-index="'form_'+ dash_id" />
      </el-aside>
      <el-main class="m-0 p-0 bg-white">
        <div class="w-full h-full">
          <el-container class="flex flex-col h-full">
            <el-header height="50px" class="flex justify-between items-center form-navigation">
              <div><span class="menu-title">{{ dash.name }}</span></div>
              <div v-if="auth.user.is_admin"><span class="menu-title"><Link :href="zroute('app.dash.edit', [app_id, dash_id])"><el-button>编辑图表</el-button></Link></span></div>
            </el-header>
            <el-main class="flex-1 overflow-y-auto">
              <editor-panel
                v-if="elements.length > 0"
                :key="timer" v-model="elements" readonly
              />
            </el-main>
          </el-container>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>

import zroute from '@/ziggy'
import Layout from '@/Shared/Layout'
import AppMenu from '../../components/AppMenu'
import {Link} from '@inertiajs/inertia-vue'
import editorPanel from '../../components/dash/editor-panel/Index'
import axios from 'axios'



export default {
  components: {
    AppMenu,
    Link,
    editorPanel,
  },
  layout: Layout,

  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    dash: {
      type: Object,
      default: () => {},
    },
    auth: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      app_id: zroute().params.app_id,
      dash_id: zroute().params.dash_id,
      elements: this.dash.widgets,
      timer: Date.now(),
    }
  },
  watch: {
  },
  created() {
    // this.getFormData();

  },
  methods: {
    getListData() {
      axios.post(zroute('app.dash.list', [this.app_id, this.dash_id])).then(res => {
        // this.elements = res.data.data.widgets;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form-navigation {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e9e9e9;
  .menu-title {
    max-width: 330px;
    font-weight: 700;
    font-size: 14px;
    line-height: 32px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.form-footer {
  align-items: flex-start;
  height: auto;
  background: #fff;
  padding: 0 24px;
  border-top: 1px dashed #e0e0e0;
}

.el-main {
  padding: 0;
  .el-result {
    padding: 0;
    width: 100%;
    height: 100%;
    margin: auto;
  }
  .fm-style {
    margin: 10px;
  }
}
</style>
